import IconButton from '@/components/Button/IconButton'
import Input from '@/components/Input'
import Spinner from '@/components/Spinner/Spinner'
import Title from '@/components/Title'
import { searchIcon } from '@/images'
import { TypeLoadData } from '@/interfaces/Fetcher'
import { GxForm, GxIcon } from '@garpix/garpix-web-components-react'
import React, { useState } from 'react'
import style from '../styles/members.module.scss'

interface IProps {
  handleFilter: TypeLoadData
  initFilters: any
  status: any
}

const Search = ({
  handleFilter,
  initFilters,
  status
}: IProps): React.ReactElement => {
  const [filter, setFilter] = useState({
    q: undefined,
    id: initFilters.element_id,
    page_size: initFilters.page_size
  })

  const inputSearch = (e): void => setFilter({ ...filter, q: e.target.value })

  const onSubmit = (): void => handleFilter(1, filter)

  return (
    <GxForm onGx-submit={onSubmit}>
      <div className={style.members_top}>
        <Title type='h2' theme='h3' className={style.members__title}>
          Участники
        </Title>
        <Input
          onGx-input={inputSearch}
          type='text'
          theme='secondary'
          placeholder='Поиск...'
          className={style.members_search}
        >
          <IconButton
            type='submit'
            theme='red'
            size='medium'
            slot='suffix'
            className={style.members_search__button}
          >
            {status === 'loading'
              ? (
                <Spinner />
                )
              : (
                <GxIcon src={searchIcon} className={style.members_search__icon} />
                )}
          </IconButton>
        </Input>
      </div>
    </GxForm>
  )
}

export default Search
